<template>
  <v-sheet :height="this.$root.windowHeight" :width="this.$root.windowWidth">
    <v-container class="fill-height" v-if="!selected">
      <v-col align="center">
        <v-row align="center" justify="center" class="mb-12">
          <h1>
            {{ headline }}
          </h1>
        </v-row>
        <v-row align="center" justify="center" v-if="!selected">
          <v-col align="center">
            <BarChart :values="genres"
                      :labels="Object.keys(stats.top_genres)"
                      :horizontal="false"
                      :selected.sync="selected"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-container>
    <v-container class="fill-height overflow-x-hidden" v-else>
      <v-row align="center" justify="center">
        <MovieWallCard :records="movies"
                   :loaded="loaded"
                   :headline="movies.length + ' en ' + selected"
                   :selected.sync="selected"
                   class="mb-3"/>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import BarChart from "@/components/charts/BarChart";
import axios from "axios";
import MovieWallCard from "@/components/MovieWallCard";
const BASE_URL = process.env.VUE_APP_API_URL
export default {
  name: "GenresWrapper",
  components: {MovieWallCard, BarChart},
  props: ['headline', 'stats'],
  data: () => {
    return {
      selected: null,
      movies: [],
      genres: [],
      genre2id: {},
      loaded: false,
    }
  },
  methods: {
    fetchMovies() {
      this.loaded = false
      axios(
          {
            method: 'get',
            url: BASE_URL + 'stats/movies/',
            params: {
              page_size: 0,
              token: this.$route.params['token'],
              user_id: this.$route.params['user_id'],
              year: this.$route.params['year'],
              genre: this.genre2id[this.selected],
            }
          }
      ).then(res => {
        this.movies = res.data
        this.loaded = true
      })
    },
    getLabels() {
      Object.keys(this.stats.top_genres).forEach((key) => {
        this.genres.push(this.stats.top_genres[key]['count'])
        this.genre2id[key] = this.stats.top_genres[key]['id']
      })
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    selected: function (newVal, oldVal) {
      if (newVal) {
        this.fetchMovies()
      } else {
        this.movies = []
        this.loaded = false
      }
    }
  },
  created() {
    this.getLabels()
  }
}
</script>

<style scoped>

</style>
